/* unplugin-vue-components disabled */import { render } from "./menu-expanded.vue?vue&type=template&id=27628490&scoped=true"
import script from "./menu-expanded.vue?vue&type=script&lang=js"
export * from "./menu-expanded.vue?vue&type=script&lang=js"

import "./menu-expanded.vue?vue&type=style&index=0&id=27628490&lang=stylus"
import "./menu-expanded.vue?vue&type=style&index=1&id=27628490&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27628490"],['__file',"src/components/navbar/menu-expanded.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27628490"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27628490', __exports__)) {
    api.reload('27628490', __exports__)
  }
  
  module.hot.accept("./menu-expanded.vue?vue&type=template&id=27628490&scoped=true", () => {
    api.rerender('27628490', render)
  })

}


export default __exports__